import React, { useState } from "react";
import { Button } from "@components/library";
import { useTranslation } from "@helpers/translate";
import "./index.sass";
import { Helmet } from "react-helmet";
import exclamationIcon from "@assets/images/icons/exclamation-mark.svg";
import TwoFactorModal from "./TwoFactorModal";
import { useDispatch, useSelector } from "react-redux";
import { disable2FA } from "@actions/user/auth2FA";


const Authentication = ({ isMobile = false, openInlinePopup = () => {} }) => {
  const [showModal, setShowModal] = useState(false);
  const { __ } = useTranslation();
  const dispatch = useDispatch();

  const { app_2fa_type } = useSelector((state) => state.user.user);
  const is2faEnabled = app_2fa_type === 'app';

  /*const getAuthenticationText = () => {
    switch (app_2fa_type) {
      case "app":
        return __("settings.google_auth");

      case "email":
        return __("settings.email_auth");

      case "sms":
        return __("settings.sms_auth");

      default:
        return __("settings.email_auth");
    }
  };*/

  const handleDisable2FA = async () => {
    await dispatch(disable2FA());
  };

  return (
    <>
      <Helmet>
        <title>
          {__("seo.two_factor_auth")} {__("seo.divider")} {__("seo.title")}
        </title>
      </Helmet>

      <div className="authentication settings">
        <header className="settings__header">
          <h1 className="settings__title">{__("settings.2fa")}</h1>
          <span className="settings__text-authenticator">
            <img src={exclamationIcon} alt="!" />
            <span>
              {__("auth.authenticatorProgram")}
            </span>
          </span>
          <p className="settings__text">
            {__("settings.2fa_text")} 
          </p>
        </header>

        <div className="authentication__btn">
          {is2faEnabled ? (
            <>
              <span className="settings__status settings__status--enabled">
                {__("settings.enabled")}
              </span>
              <Button
                type="button"
                className="authentication__btn-change"
                color="orange"
                size="middle"
                onClick={handleDisable2FA}
              >
                {__("settings.disabled")}
              </Button>
            </>
          ) : (
            // Якщо 2FA вимкнено
            <Button
              type="button"
              className="authentication__btn-change"
              color="orange"
              size="middle"
              onClick={() => {
                if (isMobile) openInlinePopup("two-factor");
                else setShowModal(true);
              }}
            >
              {__("settings.change")}
            </Button>
          )}
        </div>
      </div>

      {!isMobile && (
        <TwoFactorModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          onSuccess={() => {
            setShowModal(false);
            // Оновлення стану відбувається через Redux в post2FA action
          }}
        />
      )}
    </>
  );
};

export default Authentication;
